const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withAnimateRef = require("../hoc/withAnimateRef");
const TempCanvas = require("../util/TempCanvas");
const CanvasUtil = require("../util/CanvasUtil");
const CanvasView = require("./Canvas");
const CanvasMath = require("../canvasmath/CanvasMath");
const WebAnimations = require("../util/WebAnimations");
const ThemeColors = require("../util/ColorUtil").getThemeColorTable();
const ContainerSize = require("../util/ContainerSize");
const {getBaseInstance} = require("../util/HOCUtil");
const withContainerDims = require("../hoc/withContainerDims");
const ModalClose = require("./ModalClose");

const styles = require("./styles/MessageBubble.css");

const augment = function(Component) {
	Component = withAnimateRef(Component);
	Component = withContainerDims(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "MessageBubble",

		propTypes: {
			styleType: PT.string.isRequired,
			bubbleType: PT.oneOf([
				"slider",
				"summary",
				"instructions",
				"tutorial",
				"testoverview",
			]).isRequired,
			// By default, bubbles are the accent color of the style type. Use this for
			// a different color type.
			colorType: PT.string,
			message: PT.string.isRequired,
			canClose: PT.bool,
			handleClick: PT.func,
			shakeMessage: PT.bool,
			noSounds: PT.bool,

			minPadding: PT.shape({
				left: PT.number,
				top: PT.number,
				right: PT.number,
				bottom: PT.number,
			}),

			// Injected by HOCs
			animateRef: PT.func.isRequired,
			containerDims: PT.shape({
				width: PT.number.isRequired,
				height: PT.number.isRequired,
				left: PT.number.isRequired,
				top: PT.number.isRequired,
				windowWidth: PT.number.isRequired,
				windowHeight: PT.number.isRequired,
			}).isRequired,
		},

		getDefaultProps: function() {
			return {
				colorType: "accent",
				canClose: true,
				minPadding: {
					left: 0,
					top: 0,
					right: 0,
					bottom: 0,
				},
			};
		},

		getInitialState: function() {
			return {
				canvas: TempCanvas.requestCanvas(),
			};
		},

		componentWillUnmount: function() {
			TempCanvas.releaseCanvas(this.state.canvas);
		},

		UNSAFE_componentWillMount: function() {
			this.messageBox = this.measureMessage(this.props, this.state);
			this.bubbleSize = this.measureBubble(this.props, this.state);
		},

		UNSAFE_componentWillUpdate: function(nextProps, nextState) {
			const canvasDiv = this.messageCanvas && this.messageCanvas.containerDiv;
			if (nextProps.shakeMessage && canvasDiv) {
				this.props.animateRef(canvasDiv, WebAnimations.shake, {
					duration: 800,
					easing: "ease-in-out",
					iterations: 1,
				});
			}
			if (
				this.props.containerDims !== nextProps.containerDims ||
				nextProps.message !== this.props.message
			) {
				//If the message or page size changes, remeasure the message
				this.messageBox = this.measureMessage(nextProps, nextState);
				this.bubbleSize = this.measureBubble(nextProps, nextState);
			}
		},

		measureMessage: function(props, state) {
			//The message box takes up a specific ratio of the container
			const {message, containerDims} = props;
			const tempContext = CanvasUtil.getShortvas(state.canvas);
			const fontSize = ContainerSize.getFontSizes(containerDims).sliderMessage;
			const fontInfo = {
				family: ["Roboto Slab"],
				size: fontSize,
			};
			const {left, right, bottom} = props.minPadding;
			const wider = left || right || bottom;
			const widest = message.length > 100;
			const defaultWidth = containerDims.width / 8;
			let messageWidth = wider ? containerDims.width / 7 : defaultWidth;
			if (widest) {
				messageWidth = containerDims.width / 6;
			}
			const messageMeasure = CanvasMath.measureBatex(tempContext, {
				batex: message,
				fontInfo,
				wrapWidth: messageWidth,
			});

			// Message height should be at least as tall as width
			const messageHeight = Math.min(
				containerDims.height / 2,
				Math.max(Math.round(messageMeasure.measure.height), defaultWidth)
			);

			return {
				width: messageWidth,
				height: messageHeight,
			};
		},

		measureBubble: function(props, state) {
			const {minPadding} = props;
			const {width, height} = this.messageBox;
			const {left, right, top, bottom} = minPadding;
			// original width * 1.4 width
			// original height * 1.5 height
			const sidePadding = Math.max(width * 0.4, left + right);
			// We always need this extra * 0.5 padding for the bottom part
			const vertPadding = height * 0.5 + top + bottom;
			const bubbleSize = {
				width: Math.round(width + sidePadding),
				height: Math.round(height + vertPadding),
			};
			return bubbleSize;
		},

		drawSpeechBubble: function(context) {
			// First draw the bubble
			const offsets = [
				[0.13, 0.2],
				[0.1, 0.1],
				[0.2, 0.1],
				[0.15, 0.06],
			];
			const outlineOffsets = [0.05, 0.04, 0.07, 0.04];
			const bubbleRect = this.bubbleSize;
			const x = bubbleRect.width / 7,
				y = bubbleRect.height / 8;
			bubbleRect.x = x;
			bubbleRect.y = y;
			const width = context.getWidth() / 1.4,
				height = context.getHeight() / 1.5;
			let corners = [
				[x, y],
				[x + width, y],
				[x + width, y + height],
				[x, y + height],
			];
			for (let k = 0; k < 4; k++) {
				corners[k][0] +=
					(corners[k][0] === x ? -1 : 1) * width * outlineOffsets[k];
				corners[k][1] +=
					(corners[k][1] === y ? -1 : 1) * height * outlineOffsets[k];
			}
			const colorList = ThemeColors[this.props.styleType];
			const messageColor = colorList
				? colorList[this.props.colorType]
				: "#000000";
			context.save();
			context.clearRect(0, 0, context.getWidth(), context.getHeight());

			for (let j = 0; j < 2; j++) {
				if (j === 1) {
					corners = [
						[x, y],
						[x + width, y],
						[x + width, y + height],
						[x, y + height],
					];
				}
				context.beginPath();
				context.moveTo(corners[0][0], corners[0][1]);
				for (let i = 0; i < 4; i++) {
					const x1 = corners[i][0];
					const y1 = corners[i][1];
					const x2 = corners[(i + 1) % 4][0];
					const y2 = corners[(i + 1) % 4][1];
					const cp1x =
						x1 + width * offsets[i][0] * (i === 3 || i === 2 ? -1 : 1);
					const cp1y =
						y1 + height * offsets[i][1] * (i === 0 || i === 3 ? -1 : 1);
					const cp2x =
						x2 +
						width * offsets[(i + 1) % 4][0] * (i === 3 || i === 0 ? -1 : 1);
					const cp2y =
						y2 +
						height * offsets[(i + 1) % 4][1] * (i === 0 || i === 1 ? -1 : 1);
					context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x2, y2);
				}
				context.fillStyle = j === 1 ? messageColor : "#FFFFFF";
				context.fill();
				context.beginPath();
				context.moveTo(corners[3][0] + width * 0.4, corners[3][1]);
				context.lineTo(x + width / 2, corners[3][1] + height * 0.2);
				context.lineTo(corners[2][0] - width * 0.4, corners[2][1]);
				context.closePath();
				context.fill();
			}
			context.restore();

			// NOW draw the message

			/**
			 * The message rect is by default at bubbleSize.width / 7, bubbleSize.height / 8
			 *
			 * But this changes if we need to have a minimum padding
			 * around the message
			 *
			 * To do this, we determine how much space is unused on the left and top
			 * and shift the message rect's x- and y-coordinate if the needed padding
			 * is more than the unused space
			 */
			const {left, top} = this.props.minPadding;
			const messageRect = {
				x: Math.max(bubbleRect.x, left),
				y: Math.max(bubbleRect.y, top),
				width: this.messageBox.width,
				height: this.messageBox.height,
			};
			this.drawMessage(context, messageRect);
		},

		drawMessage: function(context, rect) {
			context.save();
			const fontSize = ContainerSize.getFontSizes(this.props.containerDims)
				.sliderMessage;

			context.fillStyle = "#FFFFFF";
			context.strokeStyle = "#FFFFFF";
			CanvasMath.drawInRect(context, {
				batex: this.props.message,
				fontInfo: {
					family: ["Roboto Slab"],
					size: fontSize,
				},
				centered: true,
				rect: [rect.x, rect.y, rect.width, rect.height],
				scaleDownOnly: true,
			});
			context.restore();
		},

		render: function() {
			const mainClass =
				styles[this.props.bubbleType] +
				" " +
				(styles[this.props.styleType] || "");
			let closeButton = null;
			if (this.props.canClose) {
				const closeClass =
					this.props.bubbleType === "instructions"
						? styles.instructionsClose
						: styles.charClose;
				closeButton = (
					<ModalClose
						extraClassName={closeClass}
						onClick={this.props.handleClick}
						noSounds={this.props.noSounds}
					/>
				);
			}

			return (
				<div className={mainClass}>
					<CanvasView
						className={styles.canvas}
						draw={this.drawSpeechBubble}
						width={this.bubbleSize.width}
						height={this.bubbleSize.height}
						ref={ref => (this.messageCanvas = getBaseInstance(ref))}
					/>
					{closeButton}
					{this.props.children}
				</div>
			);
		},
	})
);
